import type { ComponentStyleConfig } from '@chakra-ui/theme';

export const tooltipStyles: ComponentStyleConfig = {
	baseStyle: {
		borderRadius: '3px',
		bg: '#644DED',
		color: '#FFFFFF',
		fontStyle: 'normal',
		fontWeight: 500,
		fontSize: '12px',
		lineHeight: '10px',
		letterSpacing: '-0.015em',
		padding: '4px 5px',
	},
};
